import { Component, OnInit, ViewEncapsulation ,Inject} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { AccountAccessRequests } from 'src/app/Models/AccountAccessRequests';
import { FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component'; 

interface ClientRequest {
  ClientName: string;
  Phone_Number:number;
  ClientEmail: string;
  Created_On: Date;
  status: string;
}

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.css'],  
})
export class RequestListComponent implements OnInit {
  displayedColumns: string[] = ['ClientName', 'ClientEmail','BusinessName', 'Created_On', 'status', 'call'];
  dataSource: MatTableDataSource<AccountAccessRequests> = new MatTableDataSource();
  UserId: string = "";
  ManagerClientData: AccountAccessRequests[] = [];
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  displayPhoneNumber(phoneNumber: string): void {
    alert(`Phone Number: ${phoneNumber}`);
  }
  constructor(public dialog: MatDialog, private toastr: ToastrService,public service:SharkifyAiSerivceService,public router :Router,public datepipe : DatePipe,public app: AppComponent) {}

  ngOnInit(): void {
    this.ManagerClientData = [];
    this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    setTimeout(() => {
    this.getData();
  }, 100);
  }
  getData(){
    this.app.displayLoader(true);   
    this.service.ClientAccountAccessRequests(this.UserId).subscribe(data => {
      if (data.Code == 200) {
        this.ManagerClientData = data.AccountAccessRequests;
        this.ManagerClientData.forEach((element) => {
          element.ManagerFullName = element.ManagerFirstName + ' ' + element.ManagerLastName;
          element.ManagerImageText=`${Array.from(element.ManagerFirstName[0])[0]+ ""+Array.from(element.ManagerLastName[0])[0]+""}`;
          element.ManagerPhotoPic = element.ManagerPhoto == null || element.ManagerPhoto == "" || element.ManagerPhoto == "null" ? false : true;
          element.CreatedOn_text = element.CreatedOn == null || element.CreatedOn == undefined ? "" : this.datepipe.transform(element.CreatedOn,"dd-MMM-yyyy")+ "";
        });
        this.dataSource = new MatTableDataSource(this.ManagerClientData);
        console.log(this.dataSource);
        this.app.displayLoader(false);
      } else {
        this.app.displayLoader(false);
      }
    });
  }

  permissionDetails(RequestId: any){
    const dialog_data = { 
      RequestId : RequestId
     };
    const dialogRef = this.dialog.open(PermisssionDetailsDialog, {
      height: 'auto',
      width: '511px',
      data: dialog_data,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if(result.SelectionType == "Approved" || result.SelectionType == "Declined"){
          this.getData();
        }
      }
    });
  
  } 
}

export interface ManagerClientDialogData{
  RequestId : string;
}
@Component({
  selector: 'app-permission-details-dialog',
  templateUrl: './permisssion-details-dialog.html',
  styleUrls: ['./permission-details-dialog.css'],
  encapsulation: ViewEncapsulation.None
})
export class PermisssionDetailsDialog {

  disableForm: boolean = false;  
  PermissionDetailsInfo = new FormControl("");
  RequestId!: string;

 constructor(
    public dialogRef: MatDialogRef<PermisssionDetailsDialog>,
    private toastr: ToastrService,
    public service:SharkifyAiSerivceService,
    @Inject(MAT_DIALOG_DATA) public data: {element: ClientRequest,RequestId: string }
  ) {
    this.RequestId = data.RequestId;
  }

  
  acceptRequest() {
    this.service.ApproveOrDeclineAccountAccessRequest(this.RequestId,"Approved",
      this.PermissionDetailsInfo.value + "").subscribe(data => {
        if (data.Code == 200) {
          this.toastr.success('Request has been approved', 'Success', {
            timeOut: 3000,
            progressBar: true,
            positionClass: 'toast-bottom-right'
          });
          this.dialogRef.close({SelectionType : "Approved"});
        } else {
          // alert(data.Message);          
          this.dialogRef.close({SelectionType : "Error"});
        }
    })
  }

  declineRequest() {
 
    this.service.ApproveOrDeclineAccountAccessRequest(this.RequestId,"Declined",this.PermissionDetailsInfo.value+"").subscribe(data => {
      if (data.Code == 200) {
        this.toastr.warning('Request has been declined', 'Warning', {
          timeOut: 3000,
          progressBar: true,
          positionClass: 'toast-bottom-right'
        });
        this.dialogRef.close({SelectionType : "Declined"});
      } else {
        this.dialogRef.close({SelectionType : "Error"});
      }
    }) 
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
